import { Component } from '@angular/core';
import { FeedbackPlatformConversationMessageEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Conversation Messages') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformconversationmessage-form',
    templateUrl: './feedbackplatformconversationmessage.form.component.html'
})
export class FeedbackPlatformConversationMessageFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformConversationMessageEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

